import { render } from "./AllAgents.vue?vue&type=template&id=48d827fe"
import script from "./AllAgents.vue?vue&type=script&lang=js"
export * from "./AllAgents.vue?vue&type=script&lang=js"

import "./AllAgents.vue?vue&type=style&index=0&id=48d827fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__